import {VehicleLogFilterTypeEnum} from '@/enums/vehicle-log-filter-type.enum';

export function vehicleLogSortingTypeColorFilter(type: VehicleLogFilterTypeEnum) {
  switch (type) {
    case VehicleLogFilterTypeEnum.InWorkshop: return 'indigo darken-4';
    case VehicleLogFilterTypeEnum.Theft: return 'error';
    case VehicleLogFilterTypeEnum.NotPaid: return 'warning';
    case VehicleLogFilterTypeEnum.NotRentedReadyToWork: return 'success';
    case VehicleLogFilterTypeEnum.RentedAndPaid: return 'primary';
    case VehicleLogFilterTypeEnum.PrePaymentRent: return 'teal';
    default: return '';
  }
}
